import React from 'react';
import Box from 'react-styled-box';
import { Field, reduxForm } from 'redux-form';
import validation from 'sb-validate-js/validate.js';
import validators from 'validators.enum.js';
import { translation } from 'helpers/utilsHelper.js';
import { renderField, handleChatClick } from 'helpers/registerHelper.js';
import S from './StyledRegisterFormByMyIdStep1.js';

const validate = values => {
    const errors = validation(values, validators.REGISTER_BANK_STEP1);
    return errors;
};

const RegisterFormByMyIdStep1 = ({ onSubmit, initialValues, handleSubmit }) => {
    return (
        <Box flexDirection="column" alignItems="center" width="100%" as="form" onSubmit={handleSubmit(onSubmit)}>
            <S.FieldsGrid>
                <Field name="firstName" component={renderField} S={S} label={translation('registerFormBank_firstName')} disabled={!!initialValues?.firstName} />
                <Field name="lastName" component={renderField} S={S} label={translation('registerFormBank_lastName')} disabled={!!initialValues?.lastName} />
                <Field name="birthDate" component={renderField} S={S} label={translation('registerFormBank_birthDate')} disabled={!!initialValues?.birthDate} />
                <Field name="pesel" component={renderField} S={S} label={translation('registerFormBank_pesel')} disabled={!!initialValues?.pesel} />
                
                <Field name="docType" component={renderField} S={S} label={translation('registerFormBank_docType')} fullWidth disabled={!!initialValues?.docType} />
                
                <Field name="docNumber" component={renderField} S={S} label={translation('registerFormBank_docNumber')} disabled={!!initialValues?.docNumber} />
                <Field name="docExpiry" component={renderField} S={S} label={translation('registerFormBank_docExpiry')} disabled={!!initialValues?.docExpiry} />
                <Field name="countryOfBirth" component={renderField} S={S} label={translation('registerFormBank_birthCountry')} disabled={!!initialValues?.countryOfBirth} />
                <Field name="nationality" component={renderField} S={S} label={translation('registerFormBank_nationality')} disabled={!!initialValues?.nationality} />

                <Field name="accountNumber" component={renderField} S={S} label={translation('registerFormBank_accountNumber')} fullWidth disabled={!!initialValues?.accountNumber} />
            </S.FieldsGrid>
 
            <S.SubmitBtn type="submit">
                {translation('registerFormBank_next')}
            </S.SubmitBtn>

            <S.FooterInfo>
                <S.ContactInfo>{translation('registerFormBank_needHelp')}</S.ContactInfo>
                <S.ContactLink onClick={handleChatClick}>
                    {translation('registerFormBank_contactUs')}
                </S.ContactLink>
            </S.FooterInfo>
        </Box>
    );
};

export default reduxForm({
    form: 'registerWizardForm',
    validate,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: false,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true
})(RegisterFormByMyIdStep1);